export default __webpack_public_path__ + "static/media/logo_login.846a0566.png";